module.exports = __webpack_public_path__ + "static/saroj-842a04d2ed090b03bc8500fe034d3068.png";